import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const Policies = (store) => ({
  path: ROUTE.POLICIES,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'policies',
    loadReducer: () => import('./PoliciesState'),
    loadComponent: () => import('./PoliciesContainer'),
  })
})

export default Policies
